import { useState } from 'react';

import useNestClient from '../../../helper/useNestClient';
import BlogArticle from '../../blog/models/BlogArticle';

/**
 * Get the blog article to read for the current user, if any
 */
function useGetCurrentUserArticleToRead() {
  const [loading, setLoading] = useState(false);

  const { nestClient } = useNestClient();

  /**
   * Get a user blog article to read
   *
   * @return {BlogArticle | undefined}
   */
  const getArticle = async (): Promise<BlogArticle | undefined> => {
    setLoading(true);

    try {
      const url = `/users/me/article-to-read`;
      const result = await nestClient.get(url, { responseType: 'json' });

      if (result.status !== 200) {
        return undefined;
      }

      return result?.data?.article ?? undefined;
    } catch (err) {
      return undefined;
    } finally {
      setLoading(false);
    }
  };

  return { getArticle, loading };
}

export default useGetCurrentUserArticleToRead;
